import { reactive } from "vue";

export const twilioState = reactive({
  currentNumber: "+611300031113",
});
